// Get unique customers by nama (for Maklumat Pelanggan)
export const apiGetUniqueCustomersByNama = async (page = 1, limit = 10, searchParams = {}) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    ...searchParams,
  }).toString();
  return await apiRequest(`/akaun/distinct-nama?${queryParams}`);
};
// API helper functions for customer operations
// This connects to the backend API server which connects to your "akaun" table (UEU only)

import { API_BASE_URL } from "./base";
import { getCsrfToken } from "./csrf";

// API helper function to make HTTP requests
const apiRequest = async (url, options = {}) => {
  try {
  console.log(`Making API request to: ${API_BASE_URL}${url}`);

    // Try to get user department from localStorage, but don't require it
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const userDepartment = user.bahagian || null; // Allow null to show all departments

    console.log("Current user from localStorage:", user);
    console.log("User department for API request:", userDepartment || "all departments");

    if (!user.id_pengguna) {
      console.warn("No user found in localStorage. Showing all departments.");
    }

    const method = (options.method || "GET").toUpperCase();
    const csrfHeader = ["POST", "PUT", "PATCH", "DELETE"].includes(method)
      ? { "X-CSRF-Token": await getCsrfToken() }
      : {};

    const headers = {
      "Content-Type": "application/json",
      ...csrfHeader,
      ...options.headers,
    };

    // Only add department header if we have one
    if (userDepartment) {
      headers["x-bahagian-pemantau"] = userDepartment;
    }

    const response = await fetch(`${API_BASE_URL}${url}`, {
      headers: headers,
      ...options,
    });

    console.log(`Response status: ${response.status} ${response.statusText}`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error("API Error Response:", errorData);
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API Response data:", data);
    return data;
  } catch (error) {
    console.error("API request failed:", error);
    console.error("URL:", `${API_BASE_URL}${url}`);
    console.error("Options:", options);
    throw error;
  }
};

// Get customers from the database with pagination
export const apiGetAllCustomers = async (page = 1, limit = 10) => {
  console.log(`Fetching customers page ${page} with limit ${limit}...`);
  console.log(`Making request to: ${API_BASE_URL}/customers?page=${page}&limit=${limit}`);

  try {
    const result = await apiRequest(`/customers?page=${page}&limit=${limit}`);
    console.log(`Successfully fetched ${result.data ? result.data.length : 0} customers`);
    console.log("API Response:", result);
    return result;
  } catch (error) {
    console.error("Error in apiGetAllCustomers:", error);
    throw error;
  }
};

// Get total count of customers
export const apiGetCustomersCount = async () => {
  console.log("Fetching customers count...");
  return await apiRequest("/customers/count");
};

// Create a new customer
export const apiCreateCustomer = async (customerData) => {
  console.log("Creating new customer:", customerData);
  return await apiRequest("/customers", {
    method: "POST",
    body: JSON.stringify(customerData),
  });
};

// Update an existing customer
export const apiUpdateCustomer = async (id, customerData) => {
  console.log("Updating customer:", id, customerData);
  return await apiRequest(`/customers/${id}`, {
    method: "PUT",
    body: JSON.stringify(customerData),
  });
};

// Delete a customer
export const apiDeleteCustomer = async (id) => {
  console.log("Deleting customer:", id);
  return await apiRequest(`/customers/${id}`, {
    method: "DELETE",
  });
};

// Search customers with pagination
export const apiSearchCustomers = async (searchParams, page = 1, limit = 10) => {
  console.log("Searching customers:", searchParams);
  const queryParams = new URLSearchParams({
    ...searchParams,
    page: page.toString(),
    limit: limit.toString(),
  }).toString();
  return await apiRequest(`/customers/search?${queryParams}`);
};

// Get customer by IC number
export const apiGetCustomerByIC = async (noKp) => {
  console.log("Fetching customer by IC:", noKp);
  return await apiRequest(`/customers/ic/${noKp}`);
};

// Get customer by nokp
export const apiGetCustomerByNokp = async (nokp) => {
  console.log("Fetching customer by nokp:", nokp);
  const url = `/customers/ic/${encodeURIComponent(nokp)}`;
  return await apiRequest(url);
};

// Get customer by no_akaun
export const apiGetCustomerByNoAkaun = async (noAkaun) => {
  console.log("Fetching customer by no_akaun:", noAkaun);
  const url = `/customers/by-akaun/${encodeURIComponent(noAkaun)}`;
  return await apiRequest(url);
};

// Get customer by kod_pelanggan
export const apiGetCustomerByKodPelanggan = async (kodPelanggan) => {
  console.log("Fetching customer by kod_pelanggan:", kodPelanggan);
  const url = `/customers/by-kod-pelanggan/${encodeURIComponent(kodPelanggan)}`;
  return await apiRequest(url);
};

// Update an existing customer by nokp (natural key). Backend route: PUT /customers/nokp/:originalNokp
export const apiUpdateCustomerByNokp = async (originalNokp, customerData) => {
  console.log("Updating customer by nokp:", originalNokp, customerData);
  return await apiRequest(`/customers/nokp/${encodeURIComponent(originalNokp)}`, {
    method: "PUT",
    body: JSON.stringify(customerData),
  });
};

// Get customers from database as fallback (when primary API fails)
export const apiGetCustomersFallback = async (page = 1, limit = 10) => {
  console.log("Using database fallback for customer data...");

  try {
    // Try to fetch from the same API endpoints
    return await apiGetAllCustomers(page, limit);
  } catch (error) {
    console.error("Database fallback also failed:", error);
    // Return empty result if database is completely unavailable
    return {
      data: [],
      pagination: {
        currentPage: page,
        totalPages: 0,
        totalItems: 0,
        itemsPerPage: limit,
      },
    };
  }
};
